const config = {
    apiUrl: "https://test.hexaplus.fr/hexaplus/"
        //apiUrl: "https://www.hexaplus.fr/"

}
    
export default config;